var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgAbel = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 58.121,
      height: 52.955,
      viewBox: "0 0 58.121 52.955",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Asset_6",
      "data-name": "Asset 6",
      transform: "translate(0.03 0.003)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Layer_1",
      "data-name": "Layer 1",
      transform: "translate(-0.03 -0.003)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_5204",
      "data-name": "Path 5204",
      d: "M58.091,43.266c0,.167,0,.334-.013.5a9.831,9.831,0,0,1-3.207,6.712c-.1.089-.2.178-.306.264a9.666,9.666,0,0,1-4.882,2.129,10.092,10.092,0,0,1-1.279.083h-.016a9.682,9.682,0,0,1-8.144-4.465.029.029,0,0,0-.006-.01l-.445-.765-2.375-4.121a9.684,9.684,0,0,0-16.782,0l-2.375,4.121-.445.765-.007.01a9.682,9.682,0,0,1-8.144,4.465H9.652a10.081,10.081,0,0,1-1.279-.083,9.655,9.655,0,0,1-4.509-1.837c-.1-.076-.2-.156-.3-.237a9.793,9.793,0,0,1-3.59-7.837v-.02c0-.1.01-.2.016-.294a9.645,9.645,0,0,1,1.289-4.216l.264-.457L20.64,4.847a9.685,9.685,0,0,1,16.782,0L56.531,37.994l.25.434a9.745,9.745,0,0,1,1.187,3.306c.016.1.031.2.044.3v.006q.018.151.033.3c.008.073.013.146.018.222s.011.14.013.211.008.165.009.248S58.091,43.182,58.091,43.266Z",
      transform: "translate(0.03 0.003)"
    })))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgAbel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ABEL.b90638ff.svg";
export { ForwardRef as ReactComponent };